module.exports = __webpack_public_path__ + "static/media/icon_logic.696231d5.svg";